module.exports = __webpack_public_path__ + "img/img1.6f70da80.png";